<template>
  <div
    class="flex flex-col gap-8"
    :class="{
      'laptop:flex-row': props.row,
    }"
  >
    <template
      v-for="news in props.news"
      :key="news.id"
    >
      <template
        v-if="news"
      >
        <NewsCard
          :news="news"
          class="flex-1"
          :landscape="props.landscape"
        />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { News } from "~/composables/charon";

const props = defineProps<{
  landscape?: boolean,
  row?: boolean,
  news: News[]
}>()
</script>
